var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msg-content",class:_vm.type},[_c('h1',[_c('i',{class:_vm.typeItem.icon}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }